import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import Select from "react-select";
import classNames from "classnames";

import Control from "./Control";
import DropdownIndicator from "./DropdownIndicator";
import Option from "./Option";
import ValueContainer from "./ValueContainer";

export class FormDropDown extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.array,
    dataSpan: PropTypes.string,
    disabled: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    multi: PropTypes.bool,
    noLabel: PropTypes.bool,
    onValueChange: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    selectClassName: PropTypes.string,
    selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    valueContainerLabel: PropTypes.string,
    wrapperClassName: PropTypes.string
  };

  static defaultProps = {
    className: "",
    data: [],
    dataSpan: "",
    disabled: false,
    input: {},
    label: "",
    meta: {},
    multi: false,
    noLabel: false,
    onValueChange: null,
    placeholder: "",
    readOnly: false,
    selectClassName: "",
    selectedValue: "",
    valueContainerLabel: "",
    wrapperClassName: ""
  };

  get components() {
    return {
      Control,
      ClearIndicator: null,
      DropdownIndicator,
      IndicatorSeparator: null,
      ValueContainer: this.renderValueContainer,
      Option
    };
  }

  getSelectedValue = () => {
    return _.find(
      this.props.data,
      field => (field.value !== "" && field.value === this.props.input.value) || field.value === this.props.selectedValue
    );
  };

  renderValueContainer = props => <ValueContainer valueContainerLabel={this.props.valueContainerLabel} {...props} />;

  render() {
    const { className, data, disabled, input, label, meta, noLabel, placeholder, selectClassName, wrapperClassName } = this.props;
    const hasError = (meta.touched || meta.submitFailed) && meta.error;

    return (
      <fieldset className={classNames("input", className)}>
        {!noLabel && (
          <label htmlFor={input.name} className="input__label">
            {label}
          </label>
        )}

        {hasError && <span className="input__error">*{meta.error}</span>}

        <div className={classNames("input__wrapper", wrapperClassName)}>
          <Select
            {...this.props.input}
            components={this.components}
            id={input.name}
            isDisabled={disabled}
            name={input.name}
            value={this.getSelectedValue()}
            isSearchable={false}
            className={classNames("input__dropdown", selectClassName)}
            options={data}
            autosize={false}
            removeSelected={false}
            backspaceRemovesValue={false}
            placeholder={placeholder || null}
            onBlur={({ value }) => input.onBlur(value)}
            onChange={({ value }) => input.onChange(value)}
            maxMenuHeight="185"
          />
        </div>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormDropdown/FormDropDown.js